import { Navigate } from "react-router";

/**
 * The standalone /login page is superseded by the welcome-page sign-in dialog
 * (feature 011, research R3). Any hit to /login now bounces to the app root:
 * signed-out visitors land on the welcome splash, signed-in users on the app.
 */
export function LoginPage() {
  return <Navigate to="/" replace />;
}
